import { weaponLook } from '../render/weaponShapes';
import { primitiveBounds, PRIM_CAPSULE, PRIM_DISK, PRIM_ROUNDED_BOX, PRIM_TRIANGLE } from '../render/sdf/primitives';
import type { WeaponDef } from '../sim/weapons/schema';

/** The promotion card uses the same silhouette as the weapon in the arena. */
export function weaponIcon(def: WeaponDef): SVGSVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  const look = weaponLook(def.shape.kind, def.shape.length);
  const all = [...look.body, ...look.accent], bounds = all.map(primitiveBounds);
  const minX = Math.min(...bounds.map((b) => b.minX)) - 0.1, maxX = Math.max(...bounds.map((b) => b.maxX)) + 0.1;
  const minY = Math.min(...bounds.map((b) => b.minY)) - 0.1, maxY = Math.max(...bounds.map((b) => b.maxY)) + 0.1;
  svg.setAttribute('viewBox', `${minX} ${-maxY} ${maxX - minX} ${maxY - minY}`);
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('weapon-icon');
  for (const [primitives, color] of [[look.body, '#e5edf3'], [look.accent, look.accentColor]] as const) {
    const g = document.createElementNS(ns, 'g');
    g.setAttribute('transform', 'scale(1 -1)'); g.setAttribute('fill', color);
    for (const p of primitives) {
      const shape = document.createElementNS(ns, p.kind === PRIM_DISK ? 'circle' : p.kind === PRIM_CAPSULE ? 'line' : p.kind === PRIM_ROUNDED_BOX ? 'rect' : 'polygon');
      const attrs = p.kind === PRIM_DISK ? { cx: p.ax, cy: p.ay, r: p.r }
        : p.kind === PRIM_CAPSULE ? { x1: p.ax, y1: p.ay, x2: p.bx, y2: p.by, stroke: color, 'stroke-width': p.r * 2, 'stroke-linecap': 'round' }
        : p.kind === PRIM_ROUNDED_BOX ? { x: p.ax - p.bx, y: p.ay - p.by, width: p.bx * 2, height: p.by * 2, rx: p.r }
        : { points: `${p.ax - p.bx},${p.ay} ${p.ax + p.bx},${p.ay} ${p.ax},${p.ay + p.by}` };
      for (const [key, value] of Object.entries(attrs)) if (value !== undefined) shape.setAttribute(key, String(value));
      if (p.rot && (p.kind === PRIM_ROUNDED_BOX || p.kind === PRIM_TRIANGLE)) shape.setAttribute('transform', `rotate(${p.rot * 180 / Math.PI} ${p.ax} ${p.ay})`);
      g.append(shape);
    }
    svg.append(g);
  }
  return svg;
}
